import React, { useEffect, useRef, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import statsPreview from "../../../data/statsPreview";
import Background from "../../../assets/images/chill2.webp";
import "./stats-preview.css";

const StatsPreview = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            element.style.backgroundImage = `url(${Background})`;
            setIsVisible(true);
            observer.unobserve(element);
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(element);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <article ref={ref} className="homepage__stats flex-container flex-column txt-center">
      <section className="stats__items flex-container flex-column">
        {statsPreview.map((stats) => (
          <div key={stats.id} className="stats__item">
            <motion.img
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5 }}
              transition={{ duration: 1 }}
              width="50"
              height="50"
              src={stats.img}
              alt=""
              aria-hidden="true"
              loading="lazy"
            />
            <h3>
              <AnimatedCounter value={isVisible ? parseInt(stats.stats.replace(/[^\d]/g, ""), 10) : 0} />
              {stats.stats.includes("+") && "+"}
            </h3>
            <p className="pop-font txt-white">{stats.name}</p>
          </div>
        ))}
      </section>
    </article>
  );
};

const AnimatedCounter = ({ value }) => {
  const controls = useAnimation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    controls.start({ count: value });
  }, [value, controls]);

  return (
    <motion.span
      animate={controls}
      transition={{ duration: 1.5, ease: "easeOut" }}
      onUpdate={(latest) => setCount(Math.floor(latest.count))}
    >
      {count}
    </motion.span>
  );
};

export default StatsPreview;
